var map = {
	"./black.svg": "204e",
	"./black1.svg": "0b71",
	"./black2.svg": "bae6",
	"./black3.svg": "2932",
	"./blue.svg": "8c96",
	"./blue1.svg": "b887",
	"./blue2.svg": "fdf4",
	"./blue3.svg": "aa2ef",
	"./default1.svg": "e8d0",
	"./default2.svg": "99cf",
	"./default3.svg": "aecc",
	"./golden.svg": "b419",
	"./golden1.svg": "7c87e",
	"./golden2.svg": "a8ea",
	"./golden3.svg": "1020",
	"./green.svg": "92b4",
	"./green1.svg": "5ab4",
	"./green2.svg": "e70c",
	"./green3.svg": "669c",
	"./purple.svg": "b613",
	"./purple1.svg": "d4bb",
	"./purple2.svg": "9934",
	"./purple3.svg": "77199",
	"./red.svg": "bcca",
	"./red1.svg": "048a",
	"./red2.svg": "8216",
	"./red3.svg": "b981"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aebd";